import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = 'Sphere Volume Calculator - Calculate Sphere Volume Based on Radius';
const DESCRIPTION = 'Sphere Volume Calculator calculates the volume of a sphere based on the entered radius.';
const KEYWORDS = 'Sphere Volume, Calculate Sphere Volume, Sphere Volume Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/sphere-volume';
function Calculator() {
    const [radius, setRadius] = useState('');
    const [volume, setVolume] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!radius) {
            setError('Please enter the radius value correctly');
            setVolume('');
            return;
        }
        const radiusValue = parseFloat(radius);
        if (isNaN(radiusValue) || radiusValue <= 0) {
            setError('Please enter a valid and positive value for the radius');
            setVolume('');
            return;
        }
        const volumeValue = (4 / 3) * Math.PI * Math.pow(radiusValue, 3);
        setVolume(volumeValue.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>How to Calculate Sphere Volume</h2>
                                <p>
                                    Sphere volume can be calculated based on the radius using the following formula:
                                </p>
                                <p>
                                    Sphere Volume = (4/3) × π × (Radius)^3
                                </p>
                                <p>
                                    Please enter the radius value to calculate the sphere volume.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="ltr">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Radius (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Radius"
                                                value={radius}
                                                onChange={(e) => setRadius(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Calculate Sphere Volume
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {volume !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        Sphere Volume: {volume} cm³
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
